//Import created components
import Eleve from '../../components/eleve/Eleve.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getEleves } from "../../store/selectors.js";
import { elevesSlice } from "../../store/elevesSlice.js";


//Utils 
import elevesSorter from '../../utils/eleves_sorter.js';

function EleveList() {

    let allEleves = useSelector(getEleves);
    let selectedEleves = allEleves.filter((eleve) => eleve.checked === true);
    selectedEleves = elevesSorter(selectedEleves);

    return (

        <div className="eleve-list">
            {selectedEleves.map((eleve, index) => (
                <Eleve key={index} eleve={eleve} index={index} /> //index is neccessary to change the color of each eleve
            ))}

        </div>
    );
}

export default EleveList;